import React from 'react';
import { VideoIcon, MessageCircleIcon } from 'lucide-react';
interface ActionButtonsProps {
  onWatchVideo: () => void;
  onOpenChat: () => void;
}
export function ActionButtons({
  onWatchVideo,
  onOpenChat
}: ActionButtonsProps) {
  return <div className="flex gap-4 px-4 py-6" data-id="element-9">
      <button onClick={onWatchVideo} className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium" data-id="element-10">
        <VideoIcon className="w-5 h-5" data-id="element-11" />
        Watch Video
      </button>

      <button onClick={onOpenChat} className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium" data-id="element-12">
        <MessageCircleIcon className="w-5 h-5" data-id="element-13" />
        Chat with AI
      </button>
    </div>;
}